const perJenis = {
  chart: {
    type: "bar",
    height: 250,
    toolbar: {
      show: false,
    },
  },
  colors: ["#417DC3", "#6E9A34", "#DF0000", "#FF8743"],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "55%",
      borderRadius: 2,
      borderRadiusApplication: "end",
      dataLabels: {
        position: "top",
      },
    },
  },
  dataLabels: {
    enabled: true,
    formatter: (val) => Number(val).toLocaleString("id-ID"),
    offsetY: -20,
    style: {
      fontSize: "12px",
      colors: ["#417DC3", "#6E9A34", "#DF0000", "#FF8743"],
    },
  },
  stroke: {
    show: false,
  },
  xaxis: {
    type: "category",
    labels: {
      rotate: -45,
    },
  },
  yaxis: {
    labels: {
      formatter: (val) => {
        if (val > 999) return val / 1000 + 'K' 
        return val
      },
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    y: {
      formatter: (val) => Number(val).toLocaleString("id-ID") + " Bibit",
    },
  },
};

export default {
  perJenis: perJenis,
};


// WEBPACK FOOTER //
// ./src/default-page/forms/request-distribution-addendum-chart-options.js